import React, { useState } from 'react';
import Lightbox from 'react-18-image-lightbox';
import Compiler from '../compiler/Compiler';
import './style.css';
import 'react-18-image-lightbox/style.css';

const KovImage = ({ item = {}, baseUrl = '', onClick, isImageGroup = false }) => {
  const { image, attachments } = item;
  const showInfo = image?.description || image?.rightsHolder;
  const bgColor = showInfo ? 'lightgrey' : 'transparent';

  return (
    <figure className="kov-image">
      <LightBoxAnchor
        bgColor={bgColor}
        src={item?.imageM?.href}
        onClick={onClick}
        isImageGroup={isImageGroup}
      >
        <img src={item?.imageM?.href} className="img-fluid" />
        {showInfo && (
          <div className="theme-content-image__info">
            {image.description && (
              <span className="caption">
                <Compiler text={image.description} />
              </span>
            )}
            {image.rightsHolder && <span className="credit"></span>}
          </div>
        )}
      </LightBoxAnchor>
      {attachments?.map((att, i) => (
        <LightBoxAnchor key={i} bgColor={bgColor} src={baseUrl + att.href} onClick={onClick}>
          <img src={baseUrl + att.href} />
        </LightBoxAnchor>
      ))}
    </figure>
  );
};

const LightBoxAnchor = ({ bgColor, children, src, onClick, isImageGroup }) => {
  const [isOpenLight, setIsOpenLight] = useState(false);

  return (
    <>
      <a
        className={isImageGroup ? 'mx-2' : 'theme-content-image'}
        style={{ backgroundColor: bgColor, width: 'unset' }}
        onClick={() => {
          if (onClick) {
            onClick();
          } else {
            setIsOpenLight(true);
          }
        }}
      >
        {children}
      </a>
      {isOpenLight && (
        <Lightbox mainSrc={src} enableZoom={false} onCloseRequest={() => setIsOpenLight(false)} />
      )}
    </>
  );
};

export default KovImage;
